import {SvgIcon} from "@material-ui/core";
import React from "react";
import useStyles from "./styles";

export const ToggleButtonVariants = {
    Regular: 'regular',
    More: 'more',
    Row: 'row',
}

export const ToggleButton = ({ children, onSelect, variant = ToggleButtonVariants.Regular, isSelected = false }) => {
    const classes = useStyles();
    const buttonClass = `${classes.button} ${classes[variant] ?? ''}`;

    return (
        <div
            className={`MuiButtonBase-root ${buttonClass} ${isSelected ? 'Mui-selected' : ''}`}
            onKeyUp={onSelect}
            tabIndex={0}
            role={'button'}
            onClick={onSelect}
        >
            {children}
        </div>
    )
}
